module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-02.3d46ae2e.jpg";